import { Components, Theme } from '@mui/material/styles';

export const muiTabOverride: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'none',
      fontWeight: 400,
      fontSize: 16,
      minHeight: 38,
      padding: theme.spacing(4.5, 8),
      marginBottom: 0,
      color: theme.vars.palette.grey[500],
      '&.Mui-selected': {
        color: theme.vars.palette.primary[500],
      },
    }),
    icon: ({ ownerState, theme }) => ({
      marginLeft: ownerState.iconPosition === 'end' ? theme.spacing(4) : 0,
      marginRight: ownerState.iconPosition === 'start' ? theme.spacing(4) : 0,
      color: 'inherit',
    }),
  },
  defaultProps: {
    iconPosition: 'start',
  },
};
